import { useTranslation } from "react-i18next";

import { Control } from "components/ui-kit/control";
import { Frame } from "components/ui-kit/styled-templates";

import { MEAL_PLAN_OPTIONS } from "constants/config";
import districts from "constants/districts";
import countries from "constants/countries";

import accessibiltyImage from "../../../assets/images/accessibility.svg";

import { ESteps } from "types/enums";
import { putStorage, useStorageListener } from "../../../hooks/useStorage";
import _ from "lodash";
import VisibilitySwitcher from "../../auxiliary/tools/VisibilitySwitcher";

const MainInfoPage = (props) => {
    const { t } = useTranslation();

    console.log("MainInfoPage: props = ", props);
    // const dormitories = useStorageListener(`dormitories`, {});
    // console.log('-->> render: dormitories = ', dormitories);
    // checked={_.get(props, `${ESteps.MainInfo}.hideMyInfo`) == 'on'}
    let checkedVal = _.get(props, `details.hideMyInfoForAll`);

    console.log("render: checkedVal = ", checkedVal);

    return (
        <>
            <Control.Input name={`${ESteps.MainInfo}.name`} placeholder={t("1t5aml84kkt")} label={t("aadaid1hmrq")}
                           isRequired />
            <Control.Row>
                <Control.Input name={`${ESteps.MainInfo}.city`} placeholder={t("wbgx7a8dwhm")} label={t("lqi4g77bv8")}
                               isRequired
                />

                <Control.Select
                    name="district"
                    placeholder={t("to9e8pme2w")}
                    label={t("06n25w1u5eru")}
                    options={districts.map((i) => ({ value: i.id, label: i.name }))}
                />

                {/* <Control.Input name={`${ESteps.MainInfo}.cityWebsite`} placeholder="Укажите сайт города" label="Укажите сайт города" /> */}
                {/*<Control.Select*/}
                {/*    isRequired*/}
                {/*    name="country"*/}
                {/*    placeholder={"Страна"}*/}
                {/*    label={"Страна"}*/}
                {/*    options={countries.map((i) => ({ value: i.id, label: i.name }))}*/}
                {/*/>*/}
                {/*{props?.isRussia != true ? null :*/}
                {/*    <Control.Select*/}
                {/*        name="district"*/}
                {/*        placeholder={t("to9e8pme2w")}*/}
                {/*        label={t("06n25w1u5eru")}*/}
                {/*        options={districts.map((i) => ({ value: i.id, label: i.name }))}*/}
                {/*    />*/}
                {/*}*/}
            </Control.Row>
            <Control.Row>
                <Control.Input
                    name={`${ESteps.MainInfo}.street`}
                    placeholder={t("u09cuoggwi")}
                    label={t("hhiqbhty3m9")}
                    extra={`flex: 8;`}
                    isRequired
                />
                <Control.Input
                    name={`${ESteps.MainInfo}.houseNumber`}
                    placeholder={t("3olgrcg03ug")}
                    label={t("47nye1qpj0s")}
                    extra={`flex: 3;`}
                    isRequired
                />
                <Frame extra={`flex: 5; margin: 0 -8px;`} />
            </Control.Row>

            <Control.Label>{t("heq4edshron")}</Control.Label>
            <Control.Row extra={`align-items: flex-start;`}>
                <Control.Map name={`${ESteps.MainInfo}.coordinates`} extra={`width: 100%; flex: 1;`} />
                <Frame extra={`width: 100%; flex: 1;`}>
                    <Control.Input
                        name={`${ESteps.MainInfo}.coordinates.lat`}
                        placeholder={t("v6vh30yp0k")}
                        label={t("u9jaw76aym")}
                        regex="[^0-9.]"
                        isRequired
                    />
                    <Control.Input
                        name={`${ESteps.MainInfo}.coordinates.lng`}
                        placeholder={t("8oop3scd5sc")}
                        label={t("a6usrq2awrv")}
                        regex="[^0-9.]"
                        isRequired
                    />
                </Frame>
            </Control.Row>
            <Control.ButtonGroup name={`${ESteps.MainInfo}.mealPlan`} label={t("7ovx6ogekun")}
                                 options={MEAL_PLAN_OPTIONS} isRequired />
            <Control.Row>
                <Control.Input name={`${ESteps.MainInfo}.minDays`} placeholder={t("798wj6ux2at")} label={t("zv52aix35")}
                               regex="[^0-9]" isRequired />
                <Control.Input name={`${ESteps.MainInfo}.maxDays`} placeholder={t("km32lmgosz")}
                               label={t("lxsbuc65hv8")} regex="[^0-9]" isRequired />
            </Control.Row>

            <div style={{ marginTop: 20, marginBottom: 20 }}>

                <Control.Row>
                    <Control.Switch name="accessibilityEnabled" label={"Доступно для лиц с ограниченными возможностями"}
                                    extra="justify-content: flex-start;" />
                </Control.Row>

                {props?.accessibilityEnabled != true ? null :
                    <div style={{ marginTop: 15, marginBottom: 15 }}>
                        <Control.Row>
                            <Control.Textarea name="accessibilityComment"
                                              placeholder={"Информация для лиц с ограниченными возможностями здоровья"}
                                              label={"Информация для лиц с ограниченными возможностями здоровья"} />
                        </Control.Row>
                    </div>
                }

            </div>


            <Control.File multiple name={`${ESteps.MainInfo}.photos`}
                          dropzoneProps={{ label: `Загрузить фотографию (размер не более 2Мб, формат JPG, PNG)`}}
                          label={`Загрузить фотографию (рекомендуемые размеры Ширина = 1000 пикселей, Высота = 600 пикселей)`} isRequired />
            <Control.File
                multiple
                name="video"
                label={"Видео"}
                dropzoneProps={{ label: `Загрузить видео (размер не более 100Мб, формат mp4)`, icon: `dropzone-video` }}
                accept="video/mp4"
            />

            {/*@ts-ignore*/}
            <VisibilitySwitcher
                dbClassName={"Dormitory"}
                id={props.id}
                field={"hideFromAll"}
            />

            {/*<Control.Checkbox name={`${ESteps.MainInfo}.hideMyInfo`}*/}
            {/*    // checked={checkedVal}*/}
            {/*                  defaultChecked={(checkedVal == "on")}*/}
            {/*                  placeholder={""}*/}
            {/*                  label={"Скрыть информацию для всех пользователей, кроме Администратора Платформы"}*/}
            {/*    // onChange={async x => {*/}
            {/*    //   console.log('Control.Checkbox: onChange: x = ', x);*/}
            {/*    //   console.log('Control.Checkbox: onChange: x.target.value = ', x.target.value);*/}
            {/*    //   let oldChecked = (x.target.value == 'on');*/}
            {/*    //   console.log('oldChecked = ', oldChecked);*/}
            {/*    //   // let v = x.target.value;*/}
            {/*    //   // if (v == 'on'){*/}
            {/*    //   //     v = 'off'*/}
            {/*    //   // }*/}
            {/*    //   // putStorage(`details.${ESteps.MainInfo}.hideMyInfo`, v);*/}
            {/*    // }}*/}
            {/*/>*/}
        </>
    );
};

export default MainInfoPage;
